function LobbyListSlider() {
	var swiper = new Swiper(".js-lobby-list-slider", {
		slidesPerView: 1,
		navigation: {
			nextEl: ".js-lobby-list-slider-next",
			prevEl: ".js-lobby-list-slider-prev"
		},
		breakpoints: {
			// when window width is >= 768px
			768: {
				allowTouchMove: false,
				slidesPerView: 2,
			}
		}
	});
}

export { LobbyListSlider };